// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".paragraph{font-family:LaPrairie;color:#4b4b4b;font-weight:300;font-size:1.25rem;line-height:2rem;margin:1rem 0}@media screen and (max-aspect-ratio:133/100) and (min-width:640px){.paragraph{margin-top:2rem}}", ""]);
// Exports
module.exports = exports;
